import { createFileRoute } from "@tanstack/react-router";
import { Navigate } from "@tanstack/react-router";

const Component = () => {
  return (
    <Navigate to="/gym/$venueUuid/schedule/calendar" from="/gym/$venueUuid" params={true} replace />
  );
};

export const Route = createFileRoute("/gym/$venueUuid/schedule/")({
  component: Component,
});
